import { useReactable } from "@reactables/react";
import { classname } from "@jauntin/utilities";
import { RxRecentPurchasePopup } from "../Rx/RxRecentPurchasePopUp";
import CoverageService from "Services/CoverageService";
import API from "Helpers/API";
import { formatDistanceToNow } from "date-fns";
import Storage from "Helpers/Storage";
import circleXIcon from "../../../Assets/Images/sidebar-things-not-covered-icon.svg";

const RecentPurchasePopUp = () => {
  const [state, { optOut }] = useReactable(RxRecentPurchasePopup, {
    storage: Storage,
    coverageService: new CoverageService(new API()),
  });

  if (!state) return;

  const { purchase, showPopup } = state;

  return (
    <>
      <div className={classname("recent-purchase-popup", showPopup && "show")}>
        {purchase && (
          <>
            <div className="recent-purchase-popup__icon">
              <img
                src={require(`../../../Assets/Images/${purchase?.eventIcon}.svg`)}
                alt={purchase?.eventIcon}
              />
            </div>
            <div className="recent-purchase-popup__message-wrapper">
              <p className="recent-purchase-popup__message">
                {purchase?.firstName} from {purchase?.state} purchased a policy{" "}
              </p>
              <div className="recent-purchase-popup__time">
                {formatDistanceToNow(new Date(purchase?.purchaseDate))} ago
              </div>
            </div>
          </>
        )}
        <button className="circle" onClick={optOut}>
          <img src={circleXIcon} alt="Opt out" />
        </button>
      </div>
    </>
  );
};

export default RecentPurchasePopUp;
